import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailSummaryPrintButton,
} from "../../../../components/detailLayout";
import React, {useState} from "react";
import {saveIncidentReport} from "../../../../api/maintenance/IncidentService";
import SignContainer from "../../../../components/basic/SignContainer";
import {ContentCategory} from "../../../../constant/CodeSpecNum";
import {IncidentRequestInfoPanel, IncidentReportBodyPanel} from "./incidentReportPanels";

function IncidentReportCreate({incident, assets, handler, incidentReport, setIncidentReport, statusNumericValue}) {
    const [docs, setDocs] = useState([]);

    const create = async () => {
        const docFile = [];
        docs.forEach((each) => docFile.push(each.object));

        const data = {
            ...incidentReport,
            incident: {id: incident.id},
        };

        const response = await saveIncidentReport(data, docFile);
        if (response.status === 200) {
            setIncidentReport(response.data);
            alert("등록되었습니다.");
        }
    };

    const summaryMeta = [
        incident.incidentCode?.name && `유형 ${incident.incidentCode.name}`,
        incident.requester?.name && `요청 ${incident.requester.name}`,
    ].filter(Boolean).join(" · ");

    return (
        <ContentDetailInfoShell
            title={incident?.title || "장애보고서 등록"}
            meta={summaryMeta || undefined}
            contentId={incident.id}
            contentCategory={ContentCategory.INCIDENT}
            scrollMode="columns"
            trackActions
            actions={<DetailSummaryPrintButton />}
            rollup={{
                create: incident.auth?.update && create,
            }}
        >
            <ContentDetailThreeColLayout
                primary={<IncidentRequestInfoPanel incident={incident} assets={assets} handler={handler} />}
                secondary={
                    <IncidentReportBodyPanel
                        incident={incident}
                        incidentReport={incidentReport}
                        setIncidentReport={setIncidentReport}
                    />
                }
                aside={
                    <>
                        <SignContainer
                            contentId={incident.id}
                            contentCategory={"INCIDENT"}
                            statusNumericValue={statusNumericValue}
                        />
                        <DetailFilePanel
                            pendingFiles={{files: docs, setFiles: setDocs}}
                            pendingInputId="incident_report_create_doc"
                            showFileLabel={false}
                        />
                    </>
                }
            />
        </ContentDetailInfoShell>
    );
}

export {IncidentReportCreate};
